// extracted by mini-css-extract-plugin
export default {"recommendedTemplatesSection":"zqVID6","title":"xtHtLM","templatesBox":"SQZx4V","colapseBox":"AP7RQD","colapsed":"Iu9ubl","searchFadeIn":"SevAer"};